import axios from 'axios';
import { handleRequestError } from 'requests/requestHandlers';

export const createHelperApplication = (application) => {
  return axios.post('/helper_applications', application)
    .catch(res => handleRequestError(res, 'createHelperApplication'));
};
